import React, { useState } from 'react'
import '../search-customer/search-customer.scss'
import SinglePage from '../../components/common/page/SinglePage'
import SelectInput from '../../components/common/inputs/SelectInput'
import Spinner from '../../components/common/spinners/SpinWithMessage'
import TableFilter from '../../components/common/table-filter/TableFilter';
import Modal from '../../components/common/modal/Modal';
import { BiLoaderAlt } from 'react-icons/bi'
import { customerAxios } from '../../config/axios'
import { toast } from 'react-hot-toast'
import { FcSearch } from "react-icons/fc";
import { FcDeleteDatabase } from "react-icons/fc";
import { FaPlus } from 'react-icons/fa'
import { productTypes } from '../../assets/javascript/const-data';
import CUComponent from '../../components/user/bundled-components/CUComponent';



const BundledComponentsList = () => {
    const [form, setForm] = useState({ for_use: '' })
    const [modal, setModal] = useState({ status: false })
    const [loading, setLoading] = useState('')
    const [data, setData] = useState([])
    const [ifSearch, setIfSearch] = useState(false)


    const handleChange = (e) => {
        setForm({
            ...form,
            [e.target.name]: e.target.value
        })
    }

    const handleApply = (e) => {
        e.preventDefault();

        setLoading('filter')
        customerAxios.get(`/production-v0/bundled-components`, {
            params: {
                for_use: form.for_use || '',
                page: 1,
                limit: 1000,
                fields: 'label,for_use,default_rate,uuid'
            }
        })
            .then((response) => {
                setIfSearch(true)
                setData(response.data?.data || [])
                setLoading('')
            }).catch((error) => {
                toast.error(error.message)
                setLoading('')
            })
    }

    const openModel = (title, data) => {
        setModal({
            status: true, title: title, 
            content: <CUComponent setModal={setModal} currentData={data || {}} setData={setData} isEdit={data ? true : false} />
        })
    }

    return (
        <div className="search-customer-div">
            <Modal modal={modal} setModal={setModal} />
            <SinglePage titleArray={['Search Bundled Components']}>
                <div className="search-border-div">
                    <div className="filter-border-div">
                        <button className='add-button' type='button' onClick={() => openModel('Create Component', null)}> <FaPlus /> Create</button>
                        <form action="" onSubmit={handleApply}>
                            <div className="search-section">
                                <h5>Filter</h5>
                                <SelectInput label={'Product Type'} name={'for_use'} onChangeFun={handleChange}
                                    firstOption={{ option: 'Choose', value: '' }} values={productTypes?.map((a) => ({ option: a, value: a }))} />
                            </div>
                            <div className="button-div">
                                <button type='submit'>{loading === 'filter' ? <span className='loading-icon'><BiLoaderAlt /></span> : "Filter"}</button>
                            </div>
                        </form>
                    </div>

                    <div className="result-div">
                        <div className="header-div">
                            {ifSearch ? <h4>{data?.length || '0'} {data?.length > 1 ? 'Results' : 'Result'}</h4>
                                : <h4>Search Components</h4>
                            }
                            <div className="right-div">
                            </div>
                        </div>
                        <div className="items-div">
                            {data?.[0] ?
                                <TableFilter>
                                    <table className='table'>
                                        <thead>
                                            <tr>
                                                <th>Label</th>
                                                <th>Product Type</th>
                                                <th>Default Rate</th>
                                                <th>Control</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.map((comp) => {
                                                return <tr key={comp.uuid}>
                                                    <td>{comp?.label}</td>
                                                    <td>{comp?.for_use}</td>
                                                    <td>₹ {comp?.default_rate}</td>
                                                    <td>
                                                        <div className="button-div">
                                                            <button onClick={() => openModel(
                                                                'Update Component',
                                                                comp
                                                            )}>Edit</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                </TableFilter>
                                : <>
                                    <Spinner height={'300px'} spin={false} message={ifSearch ? 'No matched data' : 'Search components'}
                                        icon={ifSearch ? <FcDeleteDatabase /> : <FcSearch />} />
                                </>}
                        </div>
                    </div>
                </div>
            </SinglePage>
        </div>
    )
}

export default BundledComponentsList